import React from "react";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { MdOutlineLocalActivity } from "react-icons/md";
import { emptyStateIllustrations } from "../assets/empty-states";
import { Card, CardHeader, Coupon, EmptyState, Loading, PageWrapper } from "../components/blocks";
import { Apis } from "../util/Apis";

const Cupones = () => {
  const salaInfo = JSON.parse(localStorage.getItem("salaInfo"));

  const { data, isLoading } = useQuery({
    queryKey: ["point-coupons", salaInfo?.salaId],
    queryFn: async () => {
      const res = await axios.get(Apis.CAPP + "/point-coupons?salaId=" + salaInfo.salaId);
      return res.data;
    },
    enabled: !!salaInfo?.salaId,
  });

  const cuponesCliente = data?.coupons || [];

  return (
    <PageWrapper>
      {isLoading ? (
        <Loading />
      ) : (
        <div className="flex flex-col w-full gap-4">
          <Card>
            <CardHeader title="Cupones" subtitle="Lista de cupones" icon={<MdOutlineLocalActivity size={24} />} />
            <div className="flex flex-row items-baseline w-full gap-1">
              <span className="text-lg font-extrabold">{Math.floor(cuponesCliente.length || 0)}</span>
              <span className="font-normal text-slate-600">
                {cuponesCliente.length === 1 ? "cupon" : "cupones"}
              </span>
            </div>
          </Card>

          {cuponesCliente.length > 0 ? (
            <>
              {cuponesCliente.map((item) => (
                <Coupon
                  key={item.id}
                  couponName={item.couponName}
                  printable
                  available={item.available}
                  hexColor={item.hexColor}
                  multiplier={item.multiplier}
                  percentage={typeof item.percentage === "number" ? item.percentage / 100 : 0}
                />
              ))}
            </>
          ) : (
            <EmptyState
              title="No hay cupones disponibles en este momento"
              subtitle="Vuelva a intentarlo mas tarde"
              illustration={emptyStateIllustrations.coupons}
              illustrationAlt="Sin cupones disponibles"
            />
          )}
        </div>
      )}
    </PageWrapper>
  );
};

export default Cupones;
